import { Component, OnInit, Injector } from '@angular/core';
import { TenantDashboardServiceProxy } from '@shared/service-proxies/service-proxies';
import { DashboardChartBase } from '../dashboard-chart-base';
import { WidgetComponentBase } from '../widget-component-base';
import * as moment from 'moment';

class DashboardAnnuityNewAnnuities extends DashboardChartBase {

  newOrders = 0; newOrdersCounter = 0;
  newOrdersChange = 0; newOrdersChangeCounter = 0;

  init(newOrders, newOrdersChange) {
    this.newOrders = newOrders;
    this.newOrdersChange = newOrdersChange,
    this.hideLoading();
  }
}

@Component({
  selector: 'app-widget-annuity-new-annuities',
  templateUrl: './widget-annuity-new-annuities.component.html',
  styleUrls: ['./widget-annuity-new-annuities.component.css']
})
export class WidgetAnnuityNewAnnuitiesComponent extends WidgetComponentBase implements OnInit {

  dashboardTopStats: DashboardAnnuityNewAnnuities;
  selectedDateRange: moment.Moment[] = [moment().startOf('year'), moment().endOf('day')];
  filterAnnuitySetting: number = undefined;

  constructor(injector: Injector,
    private _tenantDashboardServiceProxy: TenantDashboardServiceProxy
  ) {
    super(injector);
    this.dashboardTopStats = new DashboardAnnuityNewAnnuities();
  }

  ngOnInit() {
    this.subDateRangeFilter();
    this.subAnnuitySettingFilter();
    this.runDelayed(this.loadTopStatsData);
  }

  loadTopStatsData = () => {
    this._tenantDashboardServiceProxy.getAnnuityNewAnnuities(this.selectedDateRange[0], this.selectedDateRange[1], this.filterAnnuitySetting).subscribe((data) => {
      this.dashboardTopStats.init(data.total, data.totalChange);
    });
  }

  onDateRangeFilterChange = (dateRange) => {
    if (!dateRange || dateRange.length !== 2 || (this.selectedDateRange[0] === dateRange[0] && this.selectedDateRange[1] === dateRange[1])) {
      return;
    }

    this.selectedDateRange[0] = dateRange[0];
    this.selectedDateRange[1] = dateRange[1];
    this.runDelayed(this.loadTopStatsData);
  }

  
  onAnnuitySettingChange = (annuitySettingId: number) => {
    this.filterAnnuitySetting = annuitySettingId;
    this.runDelayed(this.loadTopStatsData);
  }

  subDateRangeFilter() {
    abp.event.on('app.dashboardFilters.dateRangePicker.onDateChange', this.onDateRangeFilterChange);
  }

  unSubDateRangeFilter() {
    abp.event.off('app.dashboardFilters.dateRangePicker.onDateChange', this.onDateRangeFilterChange);
  }

  subAnnuitySettingFilter() {
    abp.event.on('app.dashboardFilters.annuitySettingFilter.onEventChange', this.onAnnuitySettingChange);
  }

  unSubAnnuitySettingFilter() {
    abp.event.off('app.dashboardFilters.annuitySettingFilter.onEventChange', this.onAnnuitySettingChange);
  }

  ngOnDestroy(): void {
    this.unSubDateRangeFilter();
    this.unSubAnnuitySettingFilter();
  }
}
